import { Controller } from '@hotwired/stimulus';

export default class GtmEventController extends Controller {
  static values = {
    payload: Object,
    delay: Boolean,
    debug: Boolean
  };

  connect() {
    window.dataLayer = window.dataLayer || [];
    if (!this.delayValue) this.push();
  }

  push() {
    if (!!this.debugValue) console.log('Pushing GTM event:', this.payloadValue);

    window.dataLayer.push(this.payloadValue);
  }

  // Subscription forms
  appendSubscriptionAmountAndPush(params) {
    let subscriptionAmount = null;
    if (params.hasOwnProperty('subscriptionAmount')) {
      subscriptionAmount = params.subscriptionAmount;
    } else {
      subscriptionAmount = document.getElementById('subscription_amount').value;
    }
    const investmentDetails = { ...this.payloadValue.investment_details, investment_amount: subscriptionAmount };
    this.payloadValue = { ...this.payloadValue, investment_details: investmentDetails }

    this.push();
  }
}
